import React, { useState, useRef, useEffect,useCallback } from "react";
import {
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import {
  Grid,
  Box,
  TextField,
  Typography,
  Divider,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  Button,
  FormHelperText,
} from "@mui/material";

import { api_path } from "../../shared.js";
import swal from "sweetalert";
import { useSearchParams } from "react-router-dom";
import useThaiAddress from "./useThaiAddress"; 
import ThaiAddressSection from "./ThaiAddressSection"; 
export default function VendorRegisterForm() {
    const [searchParams] = useSearchParams();
    const job_id = searchParams.get("id");
  const [form, setFormData] = useState({
    requestDate: new Date().toISOString().split("T")[0],
    vendorCode: "",
    nameTH: "",
    nameEN: "",
    address1: "",
    address2: "",
    district: "",   // Amphoe (เขต/อำเภอ)
    subdistrict: "",   // Tambon (แขวง/ตำบล)
    city: "",   // Province (จังหวัด)
    postalCode: "",
    taxId: "",
    businessType: "",
    tel: "",
    ext: "",
    mobile: "",
    otherContact: "",
    lineId: "",
    paymentType: "transfer",
    creditTerm: 0,
    remark: "",
  });
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  // ✅ ประเภทเอกสาร: "juristic" | "individual" | "organization" | ""
  const [docType, setDocType] = useState("");
  const [docTypeError, setDocTypeError] = useState(false);

  const fieldRefs = useRef({});
  const [errors, setErrors] = useState({});
  // ✅ state สำหรับเก็บตัวเลือก Business Type ที่ดึงจาก API
  const [businessTypeOptions, setBusinessTypeOptions] = useState([]);
  const [loadingBusinessType, setLoadingBusinessType] = useState(true);
 useEffect(() => {
    const fetchBusinessType = async () => {
      try {
        const res = await fetch(`${api_path}/MS_CUSTOMER_MASTER.php?type=INDUSTRY`);
        const result = await res.json();
        const list = Array.isArray(result) ? result : result.data || [];
        setBusinessTypeOptions(list);
      } catch (error) {
        console.error("Loading Business Type failed:", error);
      } finally {
        setLoadingBusinessType(false);
      }
    };
    fetchBusinessType();
  }, []);
    const makeRef = useCallback((name) => (el) => {
      fieldRefs.current[name] = el;
    }, []);
   // ── Thai Address cascade hook ──
    const {
      provinces,
      amphoes,
      tambons,
      handleProvinceChange,
      handleAmphoeChange,
      handleTambonChange,
    } = useThaiAddress(form, setFormData);
  const validate = () => {
    let newErrors = {};
    if (!form.nameTH) newErrors.nameTH = "Please enter the Thai name";
    if (!form.nameEN) newErrors.nameEN = "Please enter the English name";
     // ── Address Dropdown validation ──
    if (!form.city) newErrors.city = "Please select a province";
    if (!form.district) newErrors.district = "Please select a district";
    if (!form.subdistrict) newErrors.subdistrict = "Please select a subdistrict";
    if (!form.postalCode) {
      newErrors.postalCode = "Please enter the postal code";
    } else if (!/^\d{5}$/.test(form.postalCode)) {
      newErrors.postalCode = "The postal code must be a 5-digit number";
    }
    setErrors(newErrors);
    return {
      isValid: Object.keys(newErrors).length === 0,
      errors: newErrors,
    };
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;
    if (name === "creditTerm") {
      newValue = value === "none" ? 0 : parseInt(value);
    }
    setFormData({
      ...form,
      [name]: type === "checkbox" ? checked : newValue,
    });
  };

  const scrollToError = (errorsObj) => {
    const firstErrorKey = Object.keys(errorsObj)[0];
    if (firstErrorKey && fieldRefs.current[firstErrorKey]) {
      fieldRefs.current[firstErrorKey].scrollIntoView({ behavior: "smooth", block: "center" });
      fieldRefs.current[firstErrorKey].focus();
    }
  };

  const buildPayload = () => {
    return {
      id: job_id || null, 
      userId: localStorage.getItem("USER_ID") || null,
      vendorInfo: {
        vendorCode: form.vendorCode,
        vendorNameTH: form.nameTH,
        vendorNameEN: form.nameEN,
        address1: form.address1,
        address2: form.address2,
        subdistrict: form.subdistrict || "",
        district: form.district || "",
        city: form.city || "",
        postalCode: form.postalCode || "",
        taxId: form.taxId,
        businessType: form.businessType,
        tel: form.tel,
        ext: form.ext,
        mobile: form.mobile,
        otherContact: form.otherContact,
        lineId: form.lineId,   
        paymentType: form.paymentType,
        creditTerm: form.creditTerm,
        remark: form.remark,
        docType: docType,
        create_by: getUserID,
      },
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ เช็คว่าเลือกประเภทเอกสารหรือยัง
    if (!docType) {
      setDocTypeError(true);
      fieldRefs.current["docType"]?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    const { isValid, errors } = validate();
    if (!isValid) {
      alert("กรุณากรอกข้อมูลให้ครบ");
      scrollToError(errors);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("data", JSON.stringify(buildPayload()));
      Object.keys(files).forEach((key) => {
        files[key].forEach((file) => {
          formData.append(key, file);
        });
      });

      const response = await fetch(`${api_path}/customer/vendorRegistration.php`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (response.ok && result.status) {
        swal("Done.", "Save data successfully", "success", { buttons: true, timer: 5000 }).then(() => {
          window.location = "./CustomerRegisterDetail?id=" + result.id + "&type=3";
        });
      } else {
        alert("เกิดข้อผิดพลาด: " + result.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      alert("ไม่สามารถเชื่อมต่อ API ได้");
    }
  };

  const [files, setFiles] = useState({
    COMPANY_CERTIFICATE: [],
    COMPANY_VAT: [],
    COMPANY_PAYMENT: [],
    IDCARD: [],
    OTHERS_DOCUMENT: [],
  });

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    setFiles((prev) => ({
      ...prev,
      [name]: [...prev[name], ...Array.from(selectedFiles)],
    }));
  };

  const handleRemoveFile = async (docType, index) => {
    const file = files[docType][index];
    if (!window.confirm("ต้องการลบไฟล์นี้ใช่ไหม?")) return;
    if (file.id) {
      try {
        await fetch(`${api_path}/customer/delete-customer-file.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: file.id, file_path: file.file_path }),
        });
      } catch (error) {
        console.error("ลบไฟล์ไม่สำเร็จ", error);
      }
    }
    setFiles((prev) => {
      const updated = [...prev[docType]];
      updated.splice(index, 1);
      return { ...prev, [docType]: updated };
    });
  };

 const FILE_BASE_URL = `${api_path}/`;
  const getFileUrl    = (file) => FILE_BASE_URL + file.file_path;

  const renderUpload = (name, label) => (
    <Grid
      item
      xs={12}
      key={name}
      ref={(el) => (fieldRefs.current[name] = el)}
      sx={{
        border: "1px dashed",
        borderColor: errors[name] ? "#d32f2f" : "#ccc",
        borderRadius: 2,
        p: 2,
        mb: 2,
        bgcolor: errors[name] ? "#fff5f5" : "#fff",
      }}
    >
      <Typography variant="h6">
        {label}
        <span style={{ color: "red" }}>*</span>
      </Typography>
      <input type="file" multiple name={name} onChange={handleFileChange} style={{ margin: "10px 0" }} />
      {files[name].map((file, index) => (
        <Box key={index} display="flex" alignItems="center" gap={1}>
          <a
            href={getFileUrl(file)}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {file.name || file.file_name}
          </a>
          <Button size="small" color="error" onClick={() => handleRemoveFile(name, index)}>
            ลบ
          </Button>
        </Box>
      ))}
      {errors[name] && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {errors[name]}
        </Typography>
      )}
    </Grid>
  );

  // ✅ เอกสารแต่ละประเภท
  const renderDocumentSection = () => {
    if (!docType) return null;

    if (docType === "juristic") {
      return (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {renderUpload("COMPANY_CERTIFICATE", "Company Certificate (not more than 6 months old)")}
            {renderUpload("COMPANY_VAT", "VAT Registration Copy (if applicable)")}
            {renderUpload("COMPANY_PAYMENT", "Copy of Bank Statement or Payment Method (e.g., QR Code)")}
          </Grid>
        </Grid>
      );
    }

    if (docType === "individual") {
      return (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {renderUpload("IDCARD", "Copy of National ID Card")}
            {renderUpload("COMPANY_PAYMENT", "Copy of Bank Statement or Payment Method (e.g., QR Code)")}
          </Grid>
        </Grid>
      );
    }

    if (docType === "organization") {
      return (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {renderUpload("IDCARD", "Copy of National ID Card")}
            {renderUpload("OTHERS_DOCUMENT", "Related Documents (Please Specify)")}
            {renderUpload("COMPANY_PAYMENT", "Copy of Bank Statement or Payment Method (e.g., QR Code)")}
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <label className="head">
              New Vendor/Supplier Registration Form
            </label>
          </Grid>
        </Grid>
        <br />

        {/* Header */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Request Date"
              type="date"
              name="requestDate"
              value={form.requestDate}
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Vendor Code"
              name="vendorCode"
              value={form.vendorCode}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        {/* Vendor Info */}
        <Typography variant="h6" sx={{ mt: 4 }}>
          Information for Vendor / Supplier
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField fullWidth label="Name (TH)" name="nameTH" required value={form.nameTH} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Name (EN)" name="nameEN" required value={form.nameEN} onChange={handleChange} />
          </Grid>
              <Grid item xs={4}>
            <TextField fullWidth label="Tax ID" name="taxId" required value={form.taxId} onChange={handleChange} />
          </Grid>
          {/* <Grid item xs={12}>
            <TextField fullWidth label="ที่อยู่" required name="address1" value={form.address1} onChange={handleChange} />
          </Grid> */}
            {/* ── Thai Address Cascade Dropdowns ── */}
                    <ThaiAddressSection
                      form={form}
                      errors={errors}
                      makeRef={makeRef}
                      provinces={provinces}
                      amphoes={amphoes}
                      tambons={tambons}
                      handleProvinceChange={handleProvinceChange}
                      handleAmphoeChange={handleAmphoeChange}
                      handleTambonChange={handleTambonChange}
                    />
      
         
   
          <Grid item xs={4}>
            <TextField fullWidth label="Tel" name="tel" value={form.tel} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Ext" name="ext" value={form.ext} onChange={handleChange} />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Mobile" name="mobile" value={form.mobile} onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth label="Other Contact" name="otherContact" value={form.otherContact} onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth label="Line ID" name="lineId" onChange={handleChange} />
          </Grid>
                 <Grid item xs={6}>
            {/* <TextField fullWidth label="Business Type" required name="businessType" value={form.businessType} onChange={handleChange} /> */}
              <FormControl fullWidth required error={!!errors.businessType} size="medium">
    <InputLabel id="businessType-label">Business Type</InputLabel>
    <Select
      labelId="businessType-label"
      label="Business Type"
      name="businessType"
      value={form.businessType}
      onChange={handleChange}
      disabled={loadingBusinessType}
        sx={{
      "& .MuiSelect-select": {
        padding: "13px 12px",
      },
    }}
    >
      {businessTypeOptions.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
    {errors.businessType && (
      <FormHelperText>{errors.businessType}</FormHelperText>
    )}
  </FormControl>
          </Grid>
              <Grid item xs={6}></Grid>
        </Grid>

        {/* Payment */}
        <FormControl fullWidth>
          <Typography variant="h6" sx={{ mt: 1 }}>
            Payment Terms<span style={{ color: "red" }}>*</span>
          </Typography>
          <RadioGroup
            name="paymentType"
            value={form.paymentType}
            onChange={handleChange}
            sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1, mt: 1 }}
          >
            <FormControlLabel value="transfer" control={<Radio />} label="Transfer" sx={{ m: 0, px: 2, py: 1 }} />
            <FormControlLabel value="cheque" control={<Radio />} label="Cheque" sx={{ m: 0, px: 2, py: 1 }} />
          </RadioGroup>
        </FormControl>

        <FormControl fullWidth sx={{ mt: 2 }}>
          <Typography variant="h6" sx={{ mt: 1 }}>
            Credit Term <span style={{ color: "red" }}>*</span>
          </Typography>
          <RadioGroup
            name="creditTerm"
            value={form.creditTerm}
            onChange={handleChange}
            sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1, mt: 1 }}
          >
            {[
              { value: "0", label: "None" },
              { value: "7", label: "7 Days" },
              { value: "15", label: "15 Days" },
              { value: "30", label: "30 Days" },
            ].map((item) => (
              <FormControlLabel
                key={item.value}
                value={item.value}
                control={<Radio />}
                label={item.label}
                sx={{ borderRadius: 2, m: 0, px: 2, py: 1 }}
              />
            ))}
          </RadioGroup>
        </FormControl>

        {/* Remark */}
        <Typography variant="h6" sx={{ mt: 4 }}>
          Remark
        </Typography>
        <TextField fullWidth multiline rows={3} name="remark" value={form.remark} onChange={handleChange} />

        {/* ✅ เลือกประเภทเอกสาร */}
        <div ref={(el) => (fieldRefs.current["docType"] = el)}>
          <Typography variant="h6" sx={{ mt: 5, mb: 1 }}>
            Document Type for Consideration <span style={{ color: "red" }}>*</span>
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <RadioGroup
            row
            value={docType}
            onChange={(e) => {
              setDocType(e.target.value);
              setDocTypeError(false);
            }}
          >
            <FormControlLabel
              value="juristic"
              control={<Radio />}
              label="Juristic Person"
            />
            <FormControlLabel
              value="individual"
              control={<Radio />}
              label="Individual"
            />
            <FormControlLabel
              value="organization"
              control={<Radio />}
              label="Association / Foundation / Community Enterprise / Public Organization / Educational Institution and Others"
              sx={{ whiteSpace: "nowrap" }}
            />
          </RadioGroup>

          {docTypeError && (
            <FormHelperText error sx={{ ml: 1 }}>
             Please select the document type for consideration
            </FormHelperText>
          )}
        </div>

        {/* ✅ แสดงเอกสารตามประเภทที่เลือก */}
        {docType && (
          <>
            <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
              Document for Consideration
              {docType === "juristic" && " (Juristic Person)"}
              {docType === "individual" && " (Individual)"}
              {docType === "organization" && " (Association / Foundation / Community Enterprise / Public Organization / Educational Institution and Others)"}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {renderDocumentSection()}
          </>
        )}

        <Grid container sx={{ mt: 4 }}>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}
